/*jshint esversion: 6 */

import React from 'react';
import {connect} from "react-redux";
import {compose} from "redux";
import {firebaseConnect, getVal} from 'react-redux-firebase';
import * as actionsAccountModal from '../../actions/accountModalActions';
import CaQuizToutContainer from "../general/CaQuizToutContainer";
import CaQuizzesBannerContainer from "../general/CaQuizzesBannerContainer";
import CaQuizzesListContainer from "./CaQuizzesListContainer";



class CaQuizzesContainer extends React.Component {

    constructor(props){
        super(props);
    }

    render(){
        const { auth, userData, profile ,pageImage, quizData} = this.props;

        return(
            <div className={"Quizzes"}>

                { auth.isEmpty && <CaQuizToutContainer /> }
                { !auth.isEmpty && <CaQuizzesListContainer quizData={quizData} /> }

                <CaQuizzesBannerContainer />
            </div>
        )
    }
}




export default compose(
    connect((state) => ({
        auth: state.firebase.auth,
        userData: getVal(state.firebase, `data/quiz/${state.firebase.auth.uid}/`),
        profile:state.firebase.profile,
        quiz: state.quiz }),Object.assign({},actionsAccountModal)),
    firebaseConnect((props, store) => [
        `quiz/${store.getState().firebase.auth.uid}`
    ]),
)(CaQuizzesContainer)




